"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var UserStore = /*#__PURE__*/function (_RootStore) {
  function UserStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, UserStore);
    _this = _callSuper(this, UserStore);
    _this.config = {
      model: _models.User,
      deserialize: true,
      GET: {
        index: '/users/',
        show: '/users/:userId'
      },
      PUT: {
        update: '/users/:userId',
        addXp: '/users/:userId/add_xp',
        removeTranslations: '/users/:userId/remove_translations',
        updateTranslationSources: '/users/:userId/update_translation_sources',
        updateMailerlite: '/users/:userId/update_mailerlite',
        fetchFromRevenueCat: '/users/:userId/fetch_from_revenue_cat'
      },
      POST: {
        resetPassword: '/users/reset_password',
        create: '/users/',
        bulkCreate: '/users/bulk_create',
        blockNotifications: '/users/block_notifications'
      },
      DELETE: {
        destroy: '/users/:userId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(UserStore, _RootStore);
  return (0, _createClass2["default"])(UserStore, [{
    key: "bulkCreate",
    value: function bulkCreate(params, callback) {
      this.api(params, callback, 'POST', 'bulkCreate');
    }
  }, {
    key: "resetPassword",
    value: function resetPassword(params, callback) {
      this.api(params, callback, 'POST', 'resetPassword');
    }
  }, {
    key: "blockNotifications",
    value: function blockNotifications(params, callback) {
      this.api(params, callback, 'POST', 'blockNotifications');
    }
  }, {
    key: "addXp",
    value: function addXp(params, callback) {
      this.api(params, callback, 'PUT', 'addXp');
    }
  }, {
    key: "updateTranslationSources",
    value: function updateTranslationSources(params, callback) {
      this.api(params, callback, 'PUT', 'updateTranslationSources');
    }
  }, {
    key: "removeTranslations",
    value: function removeTranslations(params, callback) {
      this.api(params, callback, 'PUT', 'removeTranslations');
    }
  }, {
    key: "updateMailerlite",
    value: function updateMailerlite(params, callback) {
      this.api(params, callback, 'PUT', 'updateMailerlite');
    }
  }, {
    key: "fetchFromRevenueCat",
    value: function fetchFromRevenueCat(params, callback) {
      this.api(params, callback, 'PUT', 'fetchFromRevenueCat');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new UserStore();